<template>
  <div class="mobile-menu">
    <MobileMenuItem
      v-for="menuItem in menuItems"
      :key="menuItem.name"
      :label="menuItem.name"
      :icon="menuItem.icon"
      :to="menuItem.to"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, shallowRef } from "vue"
import MobileMenuItem from "./MobileMenuItem.vue"
import { CoinFlip, WheelOfFortune, Giveaways, Upgrader } from "../icons"
import { CasinoGameSlug, GameSlug } from "@/services/enums"

export default defineComponent({
  name: "MobileMenu",
  props: {},
  components: { MobileMenuItem },
  data() {
    return {
      menuItems: [
        {
          name: "Coin Flip",
          value: CasinoGameSlug.CoinFlip,
          icon: shallowRef(CoinFlip),
          to: {
            name: CasinoGameSlug.CoinFlip,
            params: { gameSlug: GameSlug.MM2 },
          },
        },
        {
          name: "Wheel",
          value: CasinoGameSlug.WheelOfFortune,
          icon: shallowRef(WheelOfFortune),
          to: {
            name: "wheel-of-fortune.rounds",
            params: { gameSlug: GameSlug.MM2 },
          },
        },
        {
          name: "Upgrader",
          value: CasinoGameSlug.Upgrader,
          icon: shallowRef(Upgrader),
          to: {
            name: "upgrader",
          },
        },
        {
          name: "Giveaways",
          value: "giveaways",
          icon: shallowRef(Giveaways),
          to: { name: "giveaways" },
        },
        // {
        //   name: "Game History",
        //   value: "game-history",
        //   icon: shallowRef(History),
        //   to: { name: "game-history" },
        // },
      ],
    }
  },
  computed: {},
  methods: {},
})
</script>
<style scoped lang="scss">
.mobile-menu {
  position: fixed;
  display: flex;
  justify-content: space-around;
  gap: 28px;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 25;
  height: 83px;
  background: var(--black-gradient);
  box-shadow: var(--black-shadow);
  box-sizing: border-box;
  padding: 16px 16px 23px 16px;
}
</style>
